// @flow
import jwtDecode from "jwt-decode";
import { Cookies } from "react-cookie";

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
  const member = getLoggedInUser();
  if (!member) {
    return false;
  }
  const decoded = jwtDecode(member.token);
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    //console.warn("access token expired");
    return false;
  } else {
    return member.token;
  }
};

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
  const cookies = new Cookies();
  const member = cookies.get("member");
  return member ? (typeof member == "object" ? member : JSON.parse(member)) : null;
};

export { isUserAuthenticated, getLoggedInUser };
